import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import OTAStackFeatureStack from "./OTAStackFeatureStack";
import OTAStackBenefit from "./OTAStackBenefit";
// Main component for OTA Device Stack
export default function OTAStack() {
  const data1 = [
    "OTA Proxy & Storage Proxy Gateway API: Validates tokens and routes requests to appropriate services, ensuring secure and efficient communication within the OTA and storage proxy infrastructure.",
    "OTA Adapter Handler: Updates firmware devices according to predefined configurations, enabling flexible and automated firmware updates across various devices.",
    "Firmware Meta Storage: Manages and stores firmware details along with associated firmware image object links, facilitating efficient organization and retrieval.",
    "Firmware Meta Notify: Notifies users of firmware update status, including stages such as idle, downloading, downloaded, updated, restarted, or failed, providing real-time feedback.",
    "Broker Service: Facilitates the transfer of device firmware status across devices and services using topics, ensuring seamless communication within a firmware management ecosystem.",
  ];

  const data2 = [
    "Third-Party OEM OTA Service: External services integrated with devices to execute OTA operations, managing firmware updates and transmitting OTA status updates.",
    "S3: Utilized to store firmware image objects, providing reliable storage and generating secure access links for firmware retrieval.",
    "IAM: Validates access tokens, ensuring secure and authorized access to resources based on defined policies and permissions.",
    "DB: Stores firmware details, OEM configuration details, and device notification statuses, serving as a centralized repository for managing firmware updates and device configurations.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["OTA Device Stack"]}
        bannerbodycopy="Investor App View | Grower App View | Buyer App View | Transporter App View | BusinessPartner App View"
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="OTA" />

      {/* Overview Features Section */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Features Section */}
      <OTAStackFeatureStack />

      {/* Benefits Section */}
      <OTAStackBenefit />

      {/* Call-to-Action */}
      <Container className="subSectionWrapper">
        <CTA
          href4="http://172.16.1.119:8910/v2/api-docs/"
          heading="Do you want to develop applications or integrate your legacy hardware and software..."
        />
      </Container>
    </>
  );
}
